import Vue from 'vue'
import Vuex from 'vuex'
import Axios from 'axios'
import Servers from "../../server";
const endPoint = Servers.serverApi;
import VuexPersistence from  "vuex-persist"
///MODULES
import Fracs from './fracs'
import Residents from './residents'
import Community from './community'
import Dashboard from './dashboard'
import Auth from './auth'
import Utils from './utils'
import Devices from './devices'
import Visitants from './visitants'
import Users from './users'
import FacialVisits from './facialVisits'


Vue.use(Vuex)

const vuexLocal = new VuexPersistence({
  key: 'vuexP',
  storage: window.localStorage,
  reducer: (state) => ({ auth: state.auth, cm: state.cm})
})


export default new Vuex.Store({
    strict: true,
    modules: {
        re: Fracs,
        cm: Community,
        fr: Residents,
        dh: Dashboard,
        auth: Auth,
        utils: Utils,
        dv: Devices,
        vs: Visitants,
        us: Users,
        fv: FacialVisits
      },
      state: {
        access_token: '',
        refresh_token:'',
        expires_in: 0,
      
      
      },
      mutations: {
       
        setToken(state, token){
          state.access_token = token
        }
      },
      getters: {
        api() {
            return Axios.create({
                headers: {
                    "Authorization": "Bearer "+ localStorage.getItem("access_token"),
                    "Accept-Language": "es-MX",
                    "Content-Type": "application/json"
                },
                baseURL: `${endPoint}`
            });
        },
      
      },
      actions: {},
      plugins:[vuexLocal.plugin]

})